createSwiper("swiper-books-author");
createSwiper("swiper-books-related");
createSwiper("swiper-books-series");
